import { t } from '@lingui/core/macro';
import styles from '../ApplicationStatusCell.module.css';

export const ManualReview = ({
  hasDocumentFeedback,
}: {
  hasDocumentFeedback: boolean;
}) => {
  return (
    <span className={styles.actionableStatus}>
      {hasDocumentFeedback ? t`Docs in review` : t`Manual check`}
    </span>
  );
};
